import React, { Component } from "react";
import styles from "../../assets/css/modules/help/accordion.css";
import ToggleDrawer from "../../components/shared/containers/ToggleDrawer";
import { handleKeyPress } from "../../helpers/KeyPressHelper";

export default class Accordion extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = { isOpen: false };
  }

  onClick = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  onKeyPress = (e) => {
    handleKeyPress(e, this.onClick);
  };

  render() {
    let headerStyles = this.state.isOpen
      ? styles.chevronTop
      : styles.chevronBottom;
      let titleStyles=this.props.ContactusForPayment?`${styles.accordion}`:`${styles.accordion} ${styles.shadow}`;

    return (
      <div className={titleStyles}>
        <h3
          className={`${headerStyles} ${styles.accordionHeading}`}
          onClick={this.onClick}
          role="button"
          tabIndex="0"
          onKeyPress={this.onKeyPress}
        >
          {this.props.question}
        </h3>
        <ToggleDrawer isOpen={this.state.isOpen} gradientClass={!this.props.ContactusForPayment?"primary":""}>
          {this.props.answer}
        </ToggleDrawer>
      </div>
    );
  }
}
